"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outlook = exports.imap = exports.gmail = void 0;

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _GmailInboxConnectOptInFlowContainerModal = _interopRequireDefault(require("./InboxConnect/GmailInboxConnectOptInFlowContainerModal"));

var _ImapInboxConnectOptInFlowContainerModal = _interopRequireDefault(require("./InboxConnect/ImapInboxConnectOptInFlowContainerModal"));

var _OutlookInboxConnectOptInFlowContainerModal = _interopRequireDefault(require("./InboxConnect/OutlookInboxConnectOptInFlowContainerModal"));

var gmail = (0, _Promptable.default)(_GmailInboxConnectOptInFlowContainerModal.default);
exports.gmail = gmail;
var imap = (0, _Promptable.default)(_ImapInboxConnectOptInFlowContainerModal.default);
exports.imap = imap;
var outlook = (0, _Promptable.default)(_OutlookInboxConnectOptInFlowContainerModal.default);
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

exports.outlook = outlook;

if (!!module && !!module.exports) {
  module.exports.default = module.exports;
}